<template>
  <v-container>
    <div>
      <s-crud
        :filter="filter"
        :config="config"
        search-input
        no-full
        height="auto"
        title="Lista de Pallets no ingresados a camara de enfriamiento"
        ref="crudPalletChamber"
        excel
      >
        <template v-slot:filter>
          <v-container>
            <v-row style="margin-left: 5px" justify="center">
              <v-col cols="6" md="3" lg="3">
                <s-select-customer
                  clearable
                  label="Cliente"
                  v-model="filter.UwoCustomerID"
                ></s-select-customer>
              </v-col>

              <v-col cols="6" md="3" lg="3">
                <s-select
                  clearable
                  label="Estado"
                  :items="statusList"
                  item-text="text"
                  item-value="value"
                  v-model="filter.StatusChamber"
                ></s-select>
              </v-col>

              <v-col cols="6" md="3" lg="2">
                <s-select-definition
                  clearable
                  :def="1173"
                  label="Cultivo"
                  v-model="filter.TypeCultive"
                />
              </v-col>

              <v-col cols="6" md="3" lg="2">
                <s-date
                  label="Fecha Inicio"
                  v-model="filter.BeginDate"
                ></s-date>
              </v-col>
              <v-col cols="6" md="3" lg="2">
                <s-date label="Fecha Fin" v-model="filter.EndDate"></s-date>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-slot:StatusChamber="{ row }">
          <v-chip small :color="getColor(row.StatusChamber)" text-color="white">
            {{ getStatusText(row.StatusChamber) }}
          </v-chip>
        </template>
      </s-crud>
    </div>
  </v-container>
</template>

<script>
//Service
import _sPrfChamberService from "../../../services/FreshProduction/PrfChamberService";
import sSelectCustomer from "../../../components/Sale/SselectClientSap.vue";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";

export default {
  components: { sSelectCustomer, SSelectDefinition },

  data: () => ({
    statusList: [
      { text: "NO INGRESADO", value: 1 },
      { text: "PENDIENTE", value: 2 },
      { text: "INGRESADO", value: 3 },
    ],
    filter: {
      BeginDate: "",
      EndDate: "",
      UwoCustomerID: null,
      StatusChamber: null,
      TypeCultive: null,
    },
    config: {
      service: {
        ..._sPrfChamberService,
        pagination: _sPrfChamberService.PalletCoolingChamberList,
      },
      model: {
        PltID: "ID",
        OrdID: "",
        PltDate: "date",
        TypeDestinyPacking: "",
        StatusChamber: "",
      },
      headers: [
        // { text: "Pck. ID", value: "PckID", width: 100 },
        { text: "Pedido", value: "OrdID", width: 70 },
        { text: "Cliente", value: "UwoCustomerName", width: 150 },
        { text: "Fecha Pallet", value: "PltDate", width: 50 },
        { text: "Plt. ID", value: "PltID", width: 40 },
        { text: "Destino", value: "TypeDestinyPacking", width: 100 },
        { text: "Calibre", value: "TypeCultive", width: 140 },
        { text: "Producto", value: "ItemName", width: 140 },
        { text: "Estado", value: "StatusChamber", width: 80 },
      ],
    },
  }),

  created() {},

  methods: {
    getStatusText(status) {
      if (status == 1 || status === "NO INGRESADO") return "NO INGRESADO";
      if (status == 2 || status === "PENDIENTE") return "PENDIENTE";
      if (status == 3 || status === "INGRESADO") return "INGRESADO";
      return status;
    },
    getColor(status) {
      if (status == 1 || status === "NO INGRESADO") return "error";
      if (status == 2 || status === "PENDIENTE") return "warning";
      if (status == 3 || status === "INGRESADO") return "success";
      return "grey"; // Color por defecto
    },
  },
};
</script>
